import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { TranslocoService } from '@ngneat/transloco';

const ACCOUNT = 'JrLOXx';
const HeadwayWidgetClassName = 'crm-change-logs-widget';
const HeadwayWidgetSelector = '.' + HeadwayWidgetClassName;

@Component({
  selector: 'crm-change-logs-widget',
  templateUrl: './change-logs-widget.component.html',
  styleUrls: ['./change-logs-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogsWidgetComponent implements OnInit, OnDestroy {
  @Input() badgePosition = 'top-right';
  @Input() widgetPosition = 'bottom-left';

  @Output() widgetReady = new EventEmitter<any>();
  @Output() showWidget = new EventEmitter<void>();
  @Output() showDetails = new EventEmitter<any>();
  @Output() readMore = new EventEmitter<any>();
  @Output() hideWidget = new EventEmitter<void>();

  headwayWidgetClassName = HeadwayWidgetClassName;

  constructor(private translocoService: TranslocoService) {}

  initHeadway(): void {
    const hwConfig = {
      selector: HeadwayWidgetSelector,
      account: ACCOUNT,
      trigger: `${HeadwayWidgetSelector} button`,
      callbacks: {
        onWidgetReady: widget => {
          this.widgetReady.emit(widget);
        },
        onShowWidget: () => this.showWidget.emit(),
        onShowDetails: changelog => this.showDetails.emit(changelog),
        onReadMore: changelog => this.readMore.emit(changelog),
        onHideWidget: () => this.hideWidget.emit(),
      },
      __component: true,
      badgePosition: this.badgePosition,
      widgetPosition: this.widgetPosition,
      translations: {
        title: this.translocoService.translate('changeLogsWidget.changeLogs'),
        readMore: this.translocoService.translate('changeLogsWidget.readMore'),
        footer: this.translocoService.translate('changeLogsWidget.fullChangeLogs'),
      },
    };
    (this as any).widget = (window as any).Headway.getNewWidget();
    (this as any).widget.init(hwConfig);
  }

  ngOnDestroy(): void {
    (this as any).widget.destroy();
  }

  ngOnInit(): void {
    this.registerTranslations();

    if ((window as any).Headway) {
      this.initHeadway();
    } else {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');

      script.onload = () => {
        this.initHeadway();
      };
      script.src = 'https://cdn.headwayapp.co/widget.js';
      head.appendChild(script);
    }
  }

  private registerTranslations(): void {
    registerTranslationsManually(
      'changeLogsWidget',
      this.translocoService,
      import.meta.webpackContext!('./translation'),
    );
  }
}
